import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const StaticDataReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                errMess: null,
                corCodes:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.COR_CODES_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, corCodes: [], loadTime: Date.now()}

        case ActionTypes.ADD_COR_CODES:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, corCodes: action.payload};

        case ActionTypes.COR_CODES_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null};

        case ActionTypes.RESET_COR_CODES_ERROR:
            return {...state, errMess: null};

        default:
            return state;
    }
};